import { render, staticRenderFns } from "./RecordSummaryCardGroup.vue?vue&type=template&id=33e8b760&"
import script from "./RecordSummaryCardGroup.vue?vue&type=script&lang=ts&"
export * from "./RecordSummaryCardGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports